
export { default as CreateExamPaperdetailInfo} from './CreateExamPaperdetailInfo';
export { default as EditExamPaperdetailInfo } from './EditExamPaperdetailInfo';
export { default as ExamPaperdetailInfoList } from './ExamPaperdeailInfoList';
export { default as Header } from '../Header';
export { default as AdminNavbar } from '../AdminNavbar';
export { default as Adminmain } from '../Adminmain';
